import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync, ILicenceDetails } from "./LicenceDetails";

export interface IMeetingDetails extends IDetailsResponse {
  meetingid: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  meetingdate: string;
  meetingtime: string;
  organisationid: string;
  location: string;
  regarding: string;
  attendeesepa: string;
  attendeesnoepa: string;
  actionitems: string;
  licenceid: string;
  originalmeetingid: string;
  organisationname: string;
  licence_regno: string;
  licenceDetails: ILicenceDetails;
}

export async function GetMeetingDetailsAsync(
  meetingId: string
): Promise<IMeetingDetails> {
  var url = `${API_URL}/MeetingCorrespondence/meetingbyid?meeting_id=${meetingId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/meeting-details`;
  }

  var response = await fetch(url);
  var body = <IMeetingDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <IMeetingDetails>{
    response: response,
    meetingid: body.meetingid,
    type: body.type,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    meetingdate: formatDate(body.meetingdate),
    meetingtime: body.meetingtime,
    organisationid: body.organisationid,
    location: body.location,
    regarding: body.regarding,
    attendeesepa: body.attendeesepa,
    attendeesnoepa: body.attendeesnoepa,
    actionitems: body.actionitems,
    originalmeetingid: body.originalmeetingid,
    organisationname: body.organisationname,
    licence_regno: licenceDetails.reg_no,
    licenceDetails: licenceDetails,
  };
}
